/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AmountDueDto { 
    principleAmount?: number;
    interestAmount?: number;
    charges?: number;
    readonly totalAmount?: number;
    readonly totalAmountWithoutRoundOff?: number;
    readonly roundOff?: number;
    dueDate?: string | null;
}

